var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.6727 6.73994C13.0813 6.36843 13.1114 5.73598 12.7399 5.32733C12.3684 4.91867 11.736 4.88855 11.3273 5.26006L6.5 9.64854L4.67267 7.98733C4.26402 7.61583 3.63157 7.64594 3.26006 8.0546C2.88855 8.46326 2.91867 9.09571 3.32733 9.46721L5.82733 11.7399C6.20875 12.0867 6.79125 12.0867 7.17267 11.7399L12.6727 6.73994Z",
    fill: "#F4F6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.08e2d88cdc525ab5fbd4a295148e2af9.svg";
export { ForwardRef as ReactComponent };